<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <smr-menu-button ></smr-menu-button>
    </ion-buttons>
    <smr-stylist-picker
      [stylistID]="stylistID"
      [readOnly]="readOnlyStylistPicker"
      [showAllStaff]="true"
      (onInit)="onStylistPickerInit($event)"
      (stylistSelect)="onStylistSelect($event)"
      cssClass="smr-stylist-picker-for-clients"
    >
    </smr-stylist-picker>

    <ion-buttons slot="end">
      <ion-button icon-only (click)="showClientExportOptions()">
        <ion-icon name="ellipsis-vertical"></ion-icon>
      </ion-button>
      <ion-button icon-only (click)="onClientAdd()">
        <ion-icon name="person-add"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="client-page">
  <ion-grid style="height: 100%" class="ion-no-padding">
    <ion-row style="height: 100%; ">
      <ion-col class="smr-client-list ion-no-padding" style="height: 100%;">
        <smr-client-picker *ngIf="stylist" [stylist]="stylist" (clientSelect)="onClientSelect($event)" class="client-picker">
        </smr-client-picker>
        
      </ion-col>
      <ion-col size="9" *ngIf="showClientDetailsOnTheRightSide()" style="border-left: solid 1px  var(--ion-color-light-eee);" class="ion-no-padding">
        <div *ngIf="!client" class="smr-empty-state ion-padding" >
          <img src="../../assets/images/select-a-client.png" />
          <h4>Select a client to view their profile.</h4>
          <br /><br />
          <ion-button fill="outline" (click)="onClientAdd()" [disabled]="isReadOnly">+ New client</ion-button>          
        </div>
        <div *ngIf="client">
          <smr-client-detail [client]="client" (clientDeleted)="onClientDelete($event)" (clientEdited)="clientEdited($event)" (clientMerged)="clientMerged($event)" (clientLoaded)="clientUpdate($event)" (profilePhoto)="setProfilePhoto($event)"></smr-client-detail>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
